export default "__VITE_ASSET__642b3b9e__"